import { render, staticRenderFns } from "./DownloadProgress.vue?vue&type=template&id=470f70db"
import script from "./DownloadProgress.vue?vue&type=script&lang=js"
export * from "./DownloadProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports